import React, { PureComponent, Fragment } from 'react';
import { Link } from 'formlabs-web-components/Link';
import { Cell } from 'formlabs-web-components/Grid';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Footer.module.css';

class FooterMenuMobileItem extends PureComponent {
  openSubMenu = () => {
    const { i, openSubMenu } = this.props;
    openSubMenu(i);
  };
  render() {
    const { i, menuItem } = this.props;
    return (
      <span
        id={`${i}_Footer`}
        styleName="top-level-mobile-menu"
        onClick={this.openSubMenu}
        onKeyUp={this.openSubMenu}
        role="button"
        tabIndex="0"
      >
        {menuItem.name}
        {menuItem.children.length > 0 && <i className="fl-navigate_next" />}
      </span>
    );
  }
}

class FooterMenuMobile extends PureComponent {
  state = {
    selected: -1
  };
  openSubMenu = i => {
    this.setState(state => ({ selected: state.selected !== i ? i : -1 }));
  };
  render() {
    const { data } = this.props;
    const { selected } = this.state;
    return (
      <Cell smallSize={24}>
        <div styleName="mobile-menu">
          {data.map((menuItem, i) => {
            return (
              <Fragment key={`main-menu-div-${i}`}>
                {menuItem.children.length >= 1 && (
                  <div
                    styleName={classNames('menu-item', {
                      selected: i === selected,
                      'submenu-opened': selected >= 0
                    })}
                    key={`main-menu-div-${i}`}
                  >
                    <FooterMenuMobileItem
                      i={i}
                      menuItem={menuItem}
                      openSubMenu={this.openSubMenu}
                    />
                    <div styleName="second-level">
                      {menuItem.children.map((menuItem, i) => {
                        return (
                          <div
                            styleName="submenu-item"
                            key={`main-menu-div-${i}`}
                          >
                            <Link
                              id={`${menuItem.name.replace(/\s/g, '')}_Footer`}
                              to={menuItem.url}
                              styleName="second-level-mobile-menu"
                            >
                              {menuItem.name}
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                {menuItem.children.length === 0 && (
                  <div
                    styleName={classNames('menu-item', {
                      selected: i === selected,
                      'submenu-opened': selected >= 0
                    })}
                    key={`main-menu-div-${i}`}
                  >
                    <Link to={menuItem.url}>{menuItem.name}</Link>
                  </div>
                )}
              </Fragment>
            );
          })}
        </div>
      </Cell>
    );
  }
}

FooterMenuMobile.propTypes = {
  splitMenu: PropTypes.array
};

export default FooterMenuMobile;
